import styles from './List.module.scss';
import NewsArrow from '../../../../../Icons/NewsArrow';

export default function NewDetailRelatedList({ fields }) {
  const articles = fields.map((newsItem) => {
    const detail = newsItem?.fields?.detail?.fields || {};
    return {
      id: newsItem.id || detail.id,
      subtitle: detail?.subtitle?.value || detail?.subtitle?.value,
      title: detail?.title?.value || detail?.title?.value,
      date: detail?.date?.value || detail?.date?.value,
      imageUrl: detail?.image?.value?.src || detail?.image?.url.src,
      url: newsItem.url || newsItem?.fields?.detail?.url || '#',
    };
  });
  const lastThree = articles.slice(-3);

  return (
    <ul className={styles.list}>
      {lastThree.map((item) => (
        <li key={item.id} className={styles.card} data-aos="fade-up">
          <a href={item.url}>
            {item.imageUrl && <img src={item.imageUrl} alt={item.title} width={500} height={300} />}
            {/* <h3 className={styles.card_subtitle}>{item.subtitle}</h3> */}
            <div className={styles.card_content}>
              <div className={styles.card_content_left}>
                <h2 className={styles.card_content_left_title}>{item.title}</h2>
                <p className={styles.card_content_left_text}>{item.date}</p>
              </div>
              <div className={styles.card_content_right}>
                <NewsArrow />
              </div>
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
}
